export default __webpack_public_path__ + "static/media/fa6-solid_lightbulb.3868af9c.svg";